(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('chatConfigCtrl', ['$scope', '$rootScope', '$state', '$uibModalInstance', '$sanitize', 'permissionService', 'teamSettingsService', 'emailSettingsService', 'growlService', 'channels', 'chatConfig', 'inboundNo', 'fb', 'currentChannel', 'twitter', 'whatsApp', 'hsms', 'rcs',
            function ($scope, $rootScope, $state, $uibModalInstance, $sanitize, permissionService, teamSettingsService, emailSettingsService, growlService, channels, chatConfig, inboundNo, fb, currentChannel, twitter, whatsApp, hsms, rcs) {

                $scope.permission = permissionService.checkPermission('chat:cfg:w');
                $scope.close = function close() {
                    $uibModalInstance.dismiss();
                };
                if (_.isEmpty(chatConfig)) {
                    chatConfig = 'noConfig';
                }

                $scope.hsms = hsms.map((h) => {
                    for (let language in h.messages) {
                        if (/{{(.|\n)*?}}/.test(h.messages[language])) {
                            delete h.messages[language];
                        }
                    }
                    return h;
                }).filter((h) => {
                    return Object.keys(h.messages).length > 0;
                });

                $scope.hsmPicked = () => {
                    $scope.channels.whatsApp.tempProperties.languages = Object.keys($scope.channels.whatsApp.tempProperties.reengagementHsm.messages);
                    $scope.channels.whatsApp.tempProperties.languageCode = $scope.channels.whatsApp.tempProperties.languages[0];
                }

                $scope.onChange = () => {
                    delete $scope.channels.whatsApp.tempProperties.reengagementHsm;
                    delete $scope.channels.whatsApp.tempProperties.languages;
                    delete $scope.channels.whatsApp.tempProperties.languageCode;
                }

                $scope.currentChannel = currentChannel;
                $scope.teamId = $state.toParams.teamId;
                $scope.id = $state.toParams.pickedApiSpaceId;
                var blockedNumbers = [];

                $scope.channels = {
                    sms: {
                        name: 'SMS Configuration',
                        properties: {
                            inboundNumber: ''
                        },
                        active: false,
                        activate: activateSms,
                        update: updateSms
                    },
                    fbMessenger: {
                        name: 'Facebook Messenger Configuration',
                        properties: {
                            "pageId": fb.pageId
                        },
                        activeForTeam: false,
                        active: false,
                        disabled: false,
                        activate: activateFb,
                        disable: disableFb,
                        update: activateFb
                    },
                    twitterDm: {
                        name: 'Twitter Configuration',
                        active: false,
                        properties: {
                            "appUserId": twitter ? twitter.appUserId : ''
                        },
                        activeForTeam: false,
                        disabled: false,
                        activate: activateTwitter,
                        disable: disableTwitter,
                        update: activateTwitter
                    },
                    appMessaging: {
                        name: 'Web Chat',
                        properties: {
                            welcomeMessage: {
                                timeout: '',
                                text: ''
                            },
                            replyAs: 'team'
                        },
                        welcomeMessageIsActive: false,
                        active: false,
                        disabled: false,
                        activate: activateAppMessaging,
                        update: updateAppMessaging
                    },
                    email: {
                        name: 'Email Configuration',
                        properties: {
                            mailboxName: '',
                            fromName: '',
                            signature: ''
                        },
                        active: false,
                        disabled: false,
                        activate: activateEmail,
                        update: updateEmail
                    },
                    whatsApp: {
                        name: 'WhatsApp Configuration',
                        active: false,
                        properties: {},
                        disabled: false,
                        activate: activateWhatsApp,
                        disable: disableWhatsApp,
                        update: activateWhatsApp
                    },
                    rcs: {
                        name: 'RCS Configuration',
                        active: false,
                        properties: {},
                        disabled: false,
                        activate: activateRcs,
                        disable: disableRcs,
                        update: activateRcs
                    }



                };

                switch ($scope.currentChannel) {

                    case 'sms':
                        processSmsConfig();
                        break;
                    case 'fbMessenger':
                        processFbConfig();
                        break;
                    case 'appMessaging':
                        processAppMessagingConfig(chatConfig);
                        break;
                    case 'email':
                        processEmailConfig();
                        break;
                    case 'twitterDm':
                        processTwitterConfig();
                        break;
                    case 'whatsApp':
                        processWhatsAppConfig(chatConfig);
                        break;
                    case 'rcs':
                        processRcsConfig(chatConfig);
                        break;
                    default:
                }


                function getTeamName(teamId) {
                    return teamSettingsService.getTeam($scope.id, teamId)
                        .then(function (data) {
                            return data.name;
                        })
                        .catch(function (error) {
                            console.error(error);
                        });
                }

                function processRcsConfig(chatConfig) {

                    if (!rcs.length || rcs === "noConfig") {
                        $scope.noRcsConfig = true;
                    } else {
                        $scope.noRcsConfig = false;
                    }

                    if (chatConfig !== 'noConfig') {
                        $scope.availableRcsConfigurations = rcs.filter(function (singleRcs) {
                            if (singleRcs.status !== "ready" && singleRcs.status !== "launched") {
                                return false;
                            }
                            var agentInUse = chatConfig.teams.find(function (team) {
                                if (team.teamId !== $scope.teamId && team.channels.rcs && team.channels.rcs.agentId.toString() === singleRcs.agentId.toString()) {
                                    return true;
                                } else if (team.teamId === $scope.teamId && team.channels.rcs && team.channels.rcs.agentId.toString() === singleRcs.agentId.toString()) {
                                    $scope.channels.rcs.active = true;
                                    $scope.channels.rcs.properties.agentId = singleRcs.agentId;
                                }
                                return false;
                            })
                            return !agentInUse;

                        });
                        for (var agent of $scope.availableRcsConfigurations) {
                            agent.label = agent.agentName + ': ' + agent.agentId;
                        }
                    }

                }

                function processWhatsAppConfig(chatConfig) {

                    $scope.channels.whatsApp.tempProperties = {};

                    if (!whatsApp.length || whatsApp === "noConfig") {
                        $scope.noWhatsAppConfig = true;
                    } else {
                        $scope.noWhatsAppConfig = false;
                    }

                    if (chatConfig !== 'noConfig') {
                        $scope.availableWhatsAppConfigurations = whatsApp.filter(function (singleWhatsApp) {
                            if (singleWhatsApp.verificationStatus !== "completed" && singleWhatsApp.configurationStatus !== "success") {
                                return false;
                            }
                            var phoneInUse = chatConfig.teams.find(function (team) {
                                if (team.teamId !== $scope.teamId && team.channels.whatsApp && team.channels.whatsApp.phoneNumber.toString() === singleWhatsApp.phoneNumber.toString()) {
                                    return true;
                                } else if (team.teamId === $scope.teamId && team.channels.whatsApp && team.channels.whatsApp.phoneNumber.toString() === singleWhatsApp.phoneNumber.toString()) {
                                    $scope.channels.whatsApp.active = true;
                                    $scope.channels.whatsApp.properties.phoneNumber = singleWhatsApp.phoneNumber;
                                    if (team.channels.whatsApp.reengagementHsm) {
                                        let hsm = $scope.hsms.find((h) => team.channels.whatsApp.reengagementHsm.templateName === h.templateName);
                                        if (hsm) {
                                            $scope.channels.whatsApp.tempProperties.reengagementHsm = hsm;
                                            $scope.channels.whatsApp.tempProperties.languages = Object.keys(hsm.messages);
                                            $scope.channels.whatsApp.tempProperties.languageCode = team.channels.whatsApp.reengagementHsm.languageCode;
                                            $scope.channels.whatsApp.allowReEngagement = true;
                                        }
                                    }
                                }
                                return false;
                            })
                            return !phoneInUse;
                        });
                    } else {
                        $scope.availableWhatsAppConfigurations = whatsApp;
                    }
                }

                function processTwitterConfig() {
                    if (!twitter || twitter === "noTwitterConfig" || !twitter.appUserId) {
                        $scope.noTwitterConfig = true;
                    } else {
                        $scope.noTwitterConfig = false;
                    }

                    if (chatConfig !== 'noConfig') {
                        chatConfig.teams.forEach(function (team) {
                            if (team.channels.twitterDm && team.teamId === $scope.teamId) {
                                $scope.channels.twitterDm.active = true;
                            } else if (team.channels.twitterDm && team.teamId !== $scope.teamId) {
                                $scope.channels.twitterDm.disabled = true;
                                getTeamName(team.teamId).then(
                                    function (name) {
                                        $scope.channels.twitterDm.teamBlocking = name;
                                    }
                                );
                            }
                        });
                        $scope.channels.twitterDm.activeForTeam = !!$scope.channels.twitterDm.active
                    }
                }

                function processFbConfig() {
                    if (!fb.pageId) {
                        $scope.noFbConfig = true;
                    } else {
                        $scope.noFbConfig = false;
                    }
                    if (chatConfig !== 'noConfig') {
                        chatConfig.teams.forEach(function (team) {
                            if (team.channels.fbMessenger && team.teamId === $scope.teamId) {
                                $scope.channels.fbMessenger.active = true;
                            } else if (team.channels.fbMessenger && team.teamId !== $scope.teamId) {
                                $scope.channels.fbMessenger.disabled = true;
                                getTeamName(team.teamId).then(
                                    function (name) {
                                        $scope.channels.fbMessenger.teamBlocking = name;
                                    }
                                );
                            }
                        });
                        $scope.channels.fbMessenger.activeForTeam = !!$scope.channels.fbMessenger.active
                    }
                }

                function processAppMessagingConfig(chatConfig) {
                    if (chatConfig !== 'noConfig') {
                        chatConfig.teams.forEach(function (team) {
                            if (team.channels.appMessaging && team.teamId === $scope.teamId) {
                                $scope.channels.appMessaging.active = true;
                                $scope.channels.appMessaging.properties = team.channels.appMessaging;
                                if (team.channels.appMessaging.welcomeMessage) {
                                    $scope.channels.appMessaging.welcomeMessageIsActive = true;
                                }
                            } else if (team.channels.appMessaging && team.channels.appMessaging.welcomeMessage && team.teamId !== $scope.teamId) {
                                getTeamName(team.teamId).then(
                                    function (name) {
                                        $scope.channels.appMessaging.teamBlocking = name;
                                    }
                                );
                            }
                        });
                    }
                }


                function processEmailConfig() {
                    $scope.emailChannelNotActive = !isChannelActivated('email');

                    if (chatConfig !== 'noConfig') {
                        chatConfig.teams.forEach(function (team) {
                            if (team.channels.email && team.teamId === $scope.teamId) {
                                $scope.channels.email.active = true;
                                $scope.channels.email.properties = team.channels.email;
                                getDataFromEmailSettings();
                            }
                        });
                    }
                }

                function activateEmail() {
                    updateEmail();
                }

                function activateAppMessaging() {
                    updateAppMessaging();
                }

                function disableWhatsApp() {
                    teamSettingsService.deleteWhatsAppConfig($scope.id, $scope.teamId)
                        .then(function (data) {
                            recalculateChannels();
                            $scope.close();
                        })
                        .catch(function (error) {
                            growlService.danger("WhatsApp chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function activateWhatsApp() {
                    var data = $scope.channels.whatsApp.properties;
                    if ($scope.channels.whatsApp.tempProperties.reengagementHsm) {
                        data.reengagementHsm = {
                            templateName: $scope.channels.whatsApp.tempProperties.reengagementHsm.templateName,
                            namespace: $scope.channels.whatsApp.tempProperties.reengagementHsm.namespace,
                            languageCode: $scope.channels.whatsApp.tempProperties.languageCode
                        }
                    }
                    teamSettingsService.updateWhatsAppConfig($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            $scope.channels.whatsApp.active = true;
                            recalculateChannels();
                            growlService.success("WhatsApp channel was activated.");
                            $scope.close();
                        })
                        .catch(function (error) {
                            console.error(error);
                            growlService.danger("WhatsApp chat wasn't activated due to: " + error.statusText);
                        });
                }

                function disableRcs() {
                    teamSettingsService.deleteRcsConfig($scope.id, $scope.teamId)
                        .then(function (data) {
                            recalculateChannels();
                            $scope.close();
                        })
                        .catch(function (error) {
                            growlService.danger("Rcs chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function activateRcs() {
                    var data = $scope.channels.rcs.properties;

                    teamSettingsService.updateRcsConfig($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            $scope.channels.rcs.active = true;
                            recalculateChannels();
                            growlService.success("Rcs channel was activated.");
                            $scope.close();
                        })
                        .catch(function (error) {
                            console.error(error);
                            growlService.danger("Rcs chat wasn't activated due to: " + error.statusText);
                        });
                }

                function disableTwitter() {
                    if (!$scope.channels.twitterDm.activeForTeam) {
                        growlService.success("Twitter channel is already disabled.");
                        $scope.close();
                    } else {
                        teamSettingsService.deleteConfigTwitter($scope.id, $scope.teamId)
                            .then(function (data) {
                                recalculateChannels();
                                $scope.close();
                            })
                            .catch(function (error) {
                                growlService.danger("Twitter chat channel wasn't turned off due to: " + error.statusText);
                            });
                    }

                }

                function activateTwitter() {
                    var data = $scope.channels.twitterDm.properties;

                    teamSettingsService.updateChatConfigTwitter($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            $scope.channels.twitterDm.active = true;
                            recalculateChannels();
                            growlService.success("Twitter channel was activated.");
                            $scope.close();
                        })
                        .catch(function (error) {
                            console.error(error);
                            growlService.danger("Twitter chat wasn't activated due to: " + error.statusText);
                        });
                }

                function disableFb() {
                    if (!$scope.channels.fbMessenger.activeForTeam) {
                        growlService.success("Fb Messenger channel is already disabled.");
                        $scope.close();
                    } else {
                        teamSettingsService.deleteConfigFb($scope.id, $scope.teamId)
                            .then(function (data) {
                                recalculateChannels();
                                $scope.close();
                            })
                            .catch(function (error) {
                                growlService.danger("Facebook Messenger chat channel wasn't turned off due to: " + error.statusText);
                            });
                    }
                }

                function activateFb() {
                    var data = $scope.channels.fbMessenger.properties;

                    teamSettingsService.updateChatConfigFb($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            $scope.channels.fbMessenger.active = true;
                            recalculateChannels();
                            growlService.success("Fb Messenger channel was updated.");
                            $scope.close();
                        })
                        .catch(function (error) {
                            console.error(error);
                            growlService.danger("Facebook Messenger chat wasn't activated due to: " + error.statusText);
                        });

                }

                function processSmsConfig() {
                    $scope.smsConfigChanged = false;
                    $scope.inboundNumbers = [];
                    if (chatConfig !== 'noConfig') {
                        setSmsChannelProperties();
                    }
                    filterTakenNumbers();

                }

                function setSmsChannelProperties() {
                    blockedNumbers = [];
                    chatConfig.teams.forEach(function (team) {
                        if (team.channels.sms) {
                            blockedNumbers.push(team.channels.sms.inboundNumber);
                            if (team.teamId === $scope.teamId) {
                                $scope.channels.sms.active = true;
                                $scope.channels.sms.properties = team.channels.sms;
                            }
                        }
                    });
                }

                function filterTakenNumbers() {
                    $scope.inboundNumbers = [];
                    if (inboundNo && inboundNo.length > 0) {
                        inboundNo.forEach(function (inbNumber) {
                            if (blockedNumbers.find(function (el) {
                                return el === inbNumber.number;
                            })) {
                                $scope.isAnyDisabled = true;
                            } else {
                                $scope.inboundNumbers.push({
                                    number: inbNumber.number
                                });

                            }
                            if ($scope.channels.sms.active && !$scope.inboundNumbers.find(function (el) {
                                return el.number === $scope.channels.sms.properties.inboundNumber;
                            })) {
                                $scope.inboundNumbers.push({
                                    number: $scope.channels.sms.properties.inboundNumber
                                });
                            }
                        });
                        if (inboundNo.length === blockedNumbers.length && !$scope.channels.sms.active) {
                            $scope.noNumberAvailable = true;
                            $scope.channels.sms.disabled = true;
                        }
                    } else {
                        if (!$scope.channels.sms.active) {
                            $scope.noNumberAvailable = true;
                            $scope.channels.sms.disabled = true;
                        }


                    }


                }

                function isChannelActivated(channelId) {
                    if (channels == 'noChannels') {
                        return false;
                    } else {
                        return channels.find(function (el) { return el.id == channelId; });
                    }
                }

                function activateSms() {
                    var data = $scope.channels.sms.properties;
                    if (data.inboundNumber.length === 0) {
                        growlService.danger("You need to choose inbound number to activate sms channel");
                        return;
                    }

                    teamSettingsService.updateChatConfigSms($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            $scope.channels.sms.active = true;
                            recalculateChannels();
                            $scope.close();
                            growlService.success("Sms channel was activated.");

                        })
                        .catch(function (error) {
                            growlService.danger("Sms channel wasn't activated due to: " + error.statusText);
                        });
                }

                function updateSms() {
                    var data = $scope.channels.sms.properties;

                    if (data.inboundNumber.length === 0) {
                        growlService.danger("You need to choose inbound number to activate sms channel");
                        return;
                    }
                    teamSettingsService.updateChatConfigSms($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            $scope.channels.sms.active = true;
                            $scope.close();
                            growlService.success("Sms channel settings were updated.");
                        })
                        .catch(function (error) {
                            growlService.danger("Sms channel settings wasn't updated due to: " + error.statusText);
                        });
                }

                function updateAppMessaging() {
                    var data = $scope.channels.appMessaging.properties;
                    if ($scope.channels.appMessaging.welcomeMessageIsActive && (data.welcomeMessage.text.length === 0 || data.welcomeMessage.timeout.length === 0)) {
                        return false;
                    } else if (!$scope.channels.appMessaging.welcomeMessageIsActive) {
                        delete data.welcomeMessage;
                    }
                    teamSettingsService.updateAppMessagingConfig($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            $scope.appConfigChanged = false;
                            chatConfig = response;
                            if (!$scope.channels.appMessaging.active) {
                                $scope.channels.appMessaging.active = true;
                                recalculateChannels();
                            }
                            processAppMessagingConfig(chatConfig);
                            growlService.success("App Messaging channel was updated.");
                            $scope.close();
                        })
                        .catch(function (error) {
                            growlService.danger("App Messaging channel wasn't activated with given configuration due to: " + error.statusText);
                        });
                }
                function getDataFromEmailSettings() {
                    return emailSettingsService.getEmailSettings($scope.id).then(
                        function (data) {
                            $scope.actualInboudEmail = $scope.channels.email.properties.mailboxName + '|' + data.apiSpaceKey + '@' + data.domain;
                            return $scope.actualInboudEmail;
                        }
                    );
                }
                function updateEmail() {
                    $scope.channels.email.properties.signature = $sanitize($scope.channels.email.properties.signature);
                    var data = $scope.channels.email.properties;
                    if (!data.mailboxName) {
                        return false;
                    }
                    data.mailboxName = data.mailboxName.toLowerCase();
                    teamSettingsService.updateEmailConfig($scope.id, $scope.teamId, data)
                        .then(function (response) {
                            chatConfig = response;
                            getDataFromEmailSettings();
                            if (!$scope.channels.email.active) {
                                $scope.channels.email.active = true;
                            }
                            recalculateChannels();
                            growlService.success("Email channel was updated.");
                            $scope.close();
                        })
                        .catch(function (error) {
                            growlService.danger("Email channel wasn't activated with given configuration due to: " + error.statusText);
                        });
                }


                $scope.activate = function activate(channel) {
                    return $scope.channels[channel].activate();
                };
                $scope.disable = function disable(channel) {
                    return $scope.channels[channel].disable();
                };
                $scope.update = function update(channel) {
                    return $scope.channels[channel].update();
                };

                $scope.chatConfigChanged = function () {
                    $scope.appConfigChanged = true;
                };

                $scope.welcomeMessageChanges = function welcomeMessageChanges() {

                    if (!$scope.channels.appMessaging.welcomeMessageIsActive) {

                        $scope.channels.appMessaging.properties.welcomeMessage = {
                            timeout: '',
                            text: ''
                        };

                    } else {
                        $scope.channels.appMessaging.properties.welcomeMessage = {
                            timeout: 7,
                            text: ''
                        };
                    }
                    $scope.chatConfigChanged();
                };

                $scope.addInbound = function (number) {

                    $scope.channels.sms.properties.inboundNumber = number;

                };

                $scope.processAppMessagingConfig = processAppMessagingConfig;
                $scope.processFbConfig = processFbConfig;
                $scope.processEmailConfig = processEmailConfig;
                $scope.processTwitterConfig = processTwitterConfig;
                $scope.processWhatsAppConfig = processWhatsAppConfig;
                $scope.processRcsConfig = processRcsConfig;
                $scope.updateSms = updateSms;
                $scope.updateAppMessaging = updateAppMessaging;
                $scope.updateEmail = updateEmail;
                $scope.activateTwitter = activateTwitter;
                $scope.activateWhatsApp = activateWhatsApp;
                $scope.activateRcs = activateRcs;

                function recalculateChannels() {
                    $rootScope.$broadcast('ChannelsCountChange', {
                        teamId: $scope.teamId
                    });
                }


            }]);

})(window.angular);